import React from 'react'
import PageList from '../../components/PageListAPI'
import { getVlm, deleteVlmById } from '../../api/vlm.api'

export default function VlmList(props) {
  return <div className='App-paper'>
    <PageList
      name='way-bill-list'
      title='познавание изображения'
      columns={[
        { id: 'id', name: '№', },
        { id: 'dateCreate', name: 'Дата создания', type: 'date', formatDate: 'LLL' },
        { id: 'status', name: 'Статус', },
        { id: 'fileName', name: 'Файл', },
      ]}
      createItem={true}
      deleteItem={true}
      loadAPI={{
        request: getVlm,
      }}
      headerInit={{
        sortBy: 'dateCreate',
        sortDirection: 'desc',
      }}
      deleteAPI={deleteVlmById}
      {...props}
    />
  </div>
}